

























import { Component, Vue, Prop } from "vue-property-decorator"
import "../../../../ui/assets/mobile/css/pass-card-dialog.css"

// eslint-disable-next-line no-unused-vars
type actionFunc = (param: UserInfo) => void
type emptyFunc = () => void

interface UserInfo {
  avatar?: string
  nick?: string
  desc?: string
  uid?: string
}

@Component
export default class SharePrompt extends Vue {
  @Prop(Array) private friendList?: Array<UserInfo>
  @Prop(String) private title?: string
  @Prop(String) private confirmText?: string
  @Prop({
    type: Function,
    default: param => {
      return param
    }
  })
  private onComplete!: actionFunc

  @Prop({
    type: Function,
    default: () => {}
  })
  private onError!: emptyFunc

  display = true
  selectedUser: UserInfo = {}
  defaultAvatar = require("../../../../ui/assets/mobile/images/avatar-unlogin.png")

  // -----------------------------computed-----------------------------
  get isShortVer(): boolean {
    return document.body.clientHeight < 500
  }

  show() {
    this.display = true
  }

  closeShareBox() {
    this.display = false
  }

  confirm() {
    if (this.selectedUser?.uid) {
      this.onComplete(this.selectedUser)
      this.closeShareBox()
    } else {
      this.onError()
    }
  }
}
